<script lang="ts" setup>
import { AbcHeading } from "@ordbogen-npm/abc-dsk";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import QuizJumbotron from "@/components/vocabularyTrainer/QuizJumbotron.vue";
import { useSettingsStore } from "@/stores";

const props = defineProps<{
  encouragementNumber: number;
}>();

const emit = defineEmits(["next"]);

const { t } = useI18n();
const settingsStore = useSettingsStore();

const encouragementImages: string[] = [
  "/assets/img/vocab/quiz/encouragement-1.gif",
  "/assets/img/vocab/quiz/encouragement-2.gif",
  "/assets/img/vocab/quiz/encouragement-3.gif",
  "/assets/img/vocab/quiz/encouragement-4.gif"
];

const encouragementImage = computed<string>(
  () => encouragementImages[props.encouragementNumber % encouragementImages.length]
);

const heading = computed<string>(() => {
  const activeLanguageGroup = settingsStore.activeLanguageGroup;

  if (activeLanguageGroup === "english") {
    return t("vocab.quizCheckpoint.jumbotronHeading.english");
  }

  if (activeLanguageGroup === "german") {
    return t("vocab.quizCheckpoint.jumbotronHeading.german");
  }

  return "";
});
</script>

<template>
  <QuizJumbotron>
    <div class="container">
      <div class="row jumbotron-inner">
        <AbcHeading tag="h1" size="xl" class="quiz-checkpoint-heading">
          {{ heading }}
        </AbcHeading>
      </div>
    </div>
  </QuizJumbotron>

  <div class="quiz-checkpoint-content container">
    <picture class="quiz-checkpoint-content-image">
      <img
        :src="encouragementImage"
        class="quiz-checkpoint-content-image-inner"
        alt=""
        role="presentation"
      />
    </picture>
  </div>

  <div class="quiz-checkpoint-button-container container">
    <div class="row">
      <TgButton size="lg" @click="emit('next')">
        {{ t("vocab.quizCheckpoint.continue") }}
      </TgButton>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.jumbotron-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 85px 0 110px;
}

.quiz-checkpoint-heading {
  text-align: center;
  white-space: pre-line;
}

.quiz-checkpoint-content {
  display: flex;
  flex-direction: column;
  margin: 24px auto;

  &-image {
    display: flex;
    position: relative;
    justify-content: center;
    margin: -80px 0 30px;

    #media-breakpoint-up(md, {
        margin-top: -90px;
    });

    &-inner {
      max-width: 200px;
      border-radius: 50%;

      #media-breakpoint-up(sm, {
        max-width: initial;
      });
    }
  }
}

.quiz-checkpoint-button-container {
  display: flex;
  justify-content: center;
  margin: 20px auto 44px;
}
</style>
